import { render, staticRenderFns } from "./ConfigAlertIris.vue?vue&type=template&id=e2604548&scoped=true"
import script from "./ConfigAlertIris.vue?vue&type=script&lang=js"
export * from "./ConfigAlertIris.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2604548",
  null
  
)

export default component.exports